<script>
export default {};
</script>

<style scoped>
</style>

<template>
  <div class="w-100 header px-5">
    <h2>Add an internal note</h2>
  </div>
</template>